'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _both = require('transmute/both');

var _both2 = _interopRequireDefault(_both);

var _SenderTypePropType = require('../../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _ChatHeadingConfigPropType = require('../../chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isEmailCapturePromptMessage = require('conversations-schema/pubnub-message/operators/isEmailCapturePromptMessage');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _areFromSameSender = require('conversations-schema/pubnub-message/operators/areFromSameSender');

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _firstFileAttachmentIdInMessage = require('conversations-schema/pubnub-message/operators/firstFileAttachmentIdInMessage');

var _EmailCapturePromptMessage = require('../../components/emailCapture/EmailCapturePromptMessage');

var _EmailCapturePromptMessage2 = _interopRequireDefault(_EmailCapturePromptMessage);

var _AutomatedChatMessage = require('../../components/AutomatedChatMessage');

var _AutomatedChatMessage2 = _interopRequireDefault(_AutomatedChatMessage);

var _VisitorChatMessage = require('../../components/VisitorChatMessage');

var _VisitorChatMessage2 = _interopRequireDefault(_VisitorChatMessage);

var _InitialChatMessage = require('../../components/InitialChatMessage');

var _InitialChatMessage2 = _interopRequireDefault(_InitialChatMessage);

var _DateLabel = require('ui-addon-messages/label/DateLabel');

var _DateLabel2 = _interopRequireDefault(_DateLabel);

var _findResponder = require('../../utils/findResponder');

var _findResponder2 = _interopRequireDefault(_findResponder);

var _chatHistoryGroups = require('../../utils/chatHistoryGroups');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisitorThreadHistoryItem = function (_React$PureComponent) {
  _inherits(VisitorThreadHistoryItem, _React$PureComponent);

  function VisitorThreadHistoryItem() {
    _classCallCheck(this, VisitorThreadHistoryItem);

    return _possibleConstructorReturn(this, (VisitorThreadHistoryItem.__proto__ || Object.getPrototypeOf(VisitorThreadHistoryItem)).apply(this, arguments));
  }

  _createClass(VisitorThreadHistoryItem, [{
    key: 'areInSameGroup',
    value: function areInSameGroup(messageA, messageB) {
      return (0, _areFromSameSender.areFromSameSender)(messageA, messageB) && (0, _both2.default)(function () {
        return (0, _messageTypeComparators.isConversationalMessage)(messageA);
      }, function () {
        return (0, _messageTypeComparators.isConversationalMessage)(messageB);
      }) && (0, _both2.default)(function () {
        return !(0, _isEmailCapturePromptMessage.isEmailCapturePromptMessage)(messageA);
      }, function () {
        return !(0, _isEmailCapturePromptMessage.isEmailCapturePromptMessage)(messageB);
      });
    }
  }, {
    key: 'senderIsTyping',
    value: function senderIsTyping(message) {
      var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

      return this.props.typingResponder && (0, _responderGetters.getUserId)(this.props.typingResponder) === senderId;
    }
  }, {
    key: 'shouldShowFooterContent',
    value: function shouldShowFooterContent() {
      var _props = this.props,
          message = _props.message,
          nextMessage = _props.nextMessage;


      if (!nextMessage && !this.senderIsTyping(message)) {
        return true;
      }

      if (this.areInSameGroup(message, nextMessage)) {
        return false;
      }

      return true;
    }
  }, {
    key: 'canPublishQuickReply',
    value: function canPublishQuickReply() {
      return !this.props.requiresExplicitConsentToProcess;
    }
  }, {
    key: 'renderDateLabel',
    value: function renderDateLabel() {
      var _props2 = this.props,
          message = _props2.message,
          previousMessage = _props2.previousMessage;


      var messageMonthAndDayText = (0, _chatHistoryGroups.getMonthAndDayText)(message);

      if (!previousMessage || messageMonthAndDayText !== (0, _chatHistoryGroups.getMonthAndDayText)(previousMessage)) {
        return _react2.default.createElement(
          _DateLabel2.default,
          { useDashedLabel: false },
          messageMonthAndDayText
        );
      }

      return null;
    }
  }, {
    key: 'renderHistoryItem',
    value: function renderHistoryItem() {
      var _props3 = this.props,
          message = _props3.message,
          nextMessage = _props3.nextMessage,
          previousMessage = _props3.previousMessage,
          responders = _props3.responders,
          currentVisitor = _props3.currentVisitor;


      var currentMessageSenderType = (0, _commonMessageFormatGetters.getSenderType)(message);

      var previousMessageSenderType = (0, _commonMessageFormatGetters.getSenderType)(previousMessage);

      var nextMessageSenderType = (0, _commonMessageFormatGetters.getSenderType)(nextMessage);

      var isFirstInGroup = !(0, _areFromSameSender.areFromSameSender)(message, previousMessage) || currentMessageSenderType !== previousMessageSenderType;

      var isLastInGroup = (!(0, _areFromSameSender.areFromSameSender)(message, nextMessage) || currentMessageSenderType !== nextMessageSenderType) && (Boolean(nextMessage) || !this.senderIsTyping(message));

      switch ((0, _commonMessageFormatGetters.getType)(message)) {
        case _messageTypes.INITIAL_MESSAGE:
          return _react2.default.createElement(_InitialChatMessage2.default, {
            message: message,
            responder: (0, _findResponder2.default)(message, responders),
            potentialResponders: this.props.potentialResponders,
            sendFromResponders: this.props.sendFromResponders,
            nextMessage: nextMessage,
            currentRole: this.props.currentRole,
            messageRole: currentMessageSenderType,
            coloring: this.props.coloring,
            isFirstInGroup: isFirstInGroup,
            isLastInGroup: isLastInGroup,
            publishMessage: this.props.publishMessage,
            republishMessage: this.props.republishMessage,
            showFooterContent: this.shouldShowFooterContent(),
            chatHeadingConfig: this.props.chatHeadingConfig,
            quickReplyDisabled: !this.canPublishQuickReply()
          });
        case _messageTypes.OFFLINE:
        case _messageTypes.CHAT_MESSAGE:
          {
            var fileId = (0, _firstFileAttachmentIdInMessage.firstFileAttachmentIdInMessage)(message);
            var fileAttachment = this.props.attachments.get(fileId);

            return _react2.default.createElement(_VisitorChatMessage2.default, {
              fileAttachment: fileAttachment,
              onAttachmentClick: this.props.onAttachmentClick,
              onAttachmentLoad: this.props.onAttachmentLoad,
              message: message,
              responder: (0, _findResponder2.default)(message, responders) || currentVisitor,
              nextMessage: nextMessage,
              currentRole: this.props.currentRole,
              messageRole: currentMessageSenderType,
              coloring: this.props.coloring,
              isFirstInGroup: isFirstInGroup,
              isLastInGroup: isLastInGroup,
              publishMessage: this.props.publishMessage,
              republishMessage: this.props.republishMessage,
              quickReplyDisabled: !this.canPublishQuickReply(),
              showFooterContent: this.shouldShowFooterContent()
            });
          }

        case _messageTypes.EMAIL_CAPTURE_PROMPT:
          return _react2.default.createElement(
            'div',
            { className: 'm-top-3 m-bottom-5' },
            _react2.default.createElement(_EmailCapturePromptMessage2.default, {
              channel: this.props.channel,
              coloring: this.props.coloring,
              message: message,
              hasVisitorEmail: this.props.hasVisitorEmail,
              systemOnline: this.props.systemOnline,
              sendVisitorEmailAddress: this.props.sendVisitorEmailAddress,
              requiresConsentToCommunicate: this.props.requiresConsentToCommunicate,
              consentToCommunicateMessage: this.props.consentToCommunicateMessage,
              companyName: this.props.companyName
            })
          );

        case _messageTypes.TYPICAL_RESPONSE_TIME:
        case _messageTypes.OFFICE_HOURS:
          return _react2.default.createElement(_AutomatedChatMessage2.default, {
            coloring: this.props.coloring,
            currentRole: this.props.currentRole,
            isFirstInGroup: isFirstInGroup,
            isLastInGroup: isLastInGroup,
            message: message,
            messageRole: currentMessageSenderType
          });

        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderDateLabel(),
        this.renderHistoryItem()
      );
    }
  }]);

  return VisitorThreadHistoryItem;
}(_react2.default.PureComponent);

VisitorThreadHistoryItem.propTypes = {
  attachments: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
  channel: _react.PropTypes.string,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord'),
  companyName: _react.PropTypes.string,
  consentToCommunicateMessage: _react.PropTypes.string,
  currentRole: _SenderTypePropType2.default.isRequired,
  currentVisitor: (0, _RecordPropType2.default)('Visitor'),
  hasVisitorEmail: _react.PropTypes.bool.isRequired,
  message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
  nextMessage: (0, _RecordPropType2.default)('PubNubMessageRecord'),
  onAttachmentClick: _react.PropTypes.func.isRequired,
  onAttachmentLoad: _react.PropTypes.func.isRequired,
  potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
  previousMessage: (0, _RecordPropType2.default)('PubNubMessageRecord'),
  publishMessage: _react.PropTypes.func,
  republishMessage: _react.PropTypes.func,
  requiresConsentToCommunicate: _react.PropTypes.bool,
  requiresExplicitConsentToProcess: _react.PropTypes.bool,
  responders: _react.PropTypes.instanceOf(_immutable.Map),
  sendFromResponders: _react.PropTypes.instanceOf(_immutable.List),
  sendVisitorEmailAddress: _react.PropTypes.func.isRequired,
  systemOnline: _react.PropTypes.bool.isRequired,
  typingResponder: (0, _RecordPropType2.default)('Responder')
};

VisitorThreadHistoryItem.defaultProps = {
  attachments: (0, _immutable.Map)(),
  onAttachmentClick: function onAttachmentClick() {}
};

exports.default = VisitorThreadHistoryItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/visitor-thread-history/components/VisitorThreadHistoryItem.js
// module id = 1085
// module chunks = 2 3